function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 73 73"
}, props), React.createElement("circle", {
  cx: "36.359",
  cy: "36.435",
  r: "35.798",
  fill: "#fff"
}), React.createElement("path", {
  d: "M56.814 22.789c-1.599.699-3.338 1.202-5.13 1.398a8.987 8.987 0 003.918-4.978 17.442 17.442 0 01-5.652 2.182 8.89 8.89 0 00-2.962-2.114 8.783 8.783 0 00-3.547-.74c-4.937 0-8.908 4.056-8.908 9.034 0 .699.084 1.398.22 2.07-7.392-.391-13.985-3.971-18.368-9.452a9.061 9.061 0 00-1.212 4.56c0 3.134 1.573 5.899 3.97 7.524a8.893 8.893 0 01-4.027-1.149v.111c0 4.39 3.061 8.029 7.141 8.865a9.318 9.318 0 01-2.346.307 11.7 11.7 0 01-1.682-.137c1.129 3.58 4.415 6.18 8.327 6.264a17.701 17.701 0 01-11.059 3.861c-.747 0-1.437-.027-2.152-.111a24.978 24.978 0 0013.681 4.05c16.383 0 25.348-13.757 25.348-25.699 0-.392 0-.783-.027-1.175a19.332 19.332 0 004.467-4.671z",
  fill: "#59A3BD"
})));